import Person from './Person'
import { PersonListWrapper } from './Styles'
import { PersonProps } from '.'

type PersonPropsExtended = PersonProps & {
  id: string
}

interface PersonListProps {
  persons: PersonPropsExtended[]
}

const PersonList = ({ persons = [] }: PersonListProps) => (
  <PersonListWrapper>
    {persons.map(props => (
      <Person key={props.id} {...props} />
    ))}
  </PersonListWrapper>
)

export default PersonList
